import { c as _c } from "react/compiler-runtime";
import type { DataIdentifierFormData, VaultFormData } from '@onefootprint/core';
import { Form } from '@onefootprint/ui';
import type { Path } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getOtherInputFormName, otherLabelValue } from '../utils/constants';
type DropdownProps = {
  name: string;
  label: string;
  options: string[];
  includeOther?: boolean;
  placeholder?: string;
  required: boolean;
};
export const Dropdown = t0 => {
  const $ = _c(30);
  const {
    name,
    label,
    options,
    includeOther,
    placeholder,
    required
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCustomData.pages.customDataForm"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const t2 = name as Path<VaultFormData>;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      name: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const dropdownValue = useWatch(t3);
  const t4 = name as DataIdentifierFormData;
  let t5;
  if ($[3] !== t4) {
    t5 = getOtherInputFormName(t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const otherInputName = t5;
  let t6;
  if ($[5] !== includeOther || $[6] !== options) {
    let t7;
    if ($[8] !== includeOther) {
      t7 = includeOther ? [otherLabelValue] : [];
      $[8] = includeOther;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    t6 = [...options.map(_temp), ...t7];
    $[5] = includeOther;
    $[6] = options;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[10] !== required || $[11] !== t) {
    t7 = required ? t(_temp2) : undefined;
    $[10] = required;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = {
      required: t7
    };
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== label || $[16] !== name || $[17] !== placeholder || $[18] !== t6 || $[19] !== t8) {
    t9 = <Form.Select name={name} label={label} placeholder={placeholder} options={t6} rules={t8} />;
    $[15] = label;
    $[16] = name;
    $[17] = placeholder;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== dropdownValue || $[22] !== includeOther || $[23] !== otherInputName || $[24] !== required || $[25] !== t) {
    t10 = includeOther && dropdownValue === otherLabelValue.value && <Form.Input autoComplete="off" autoFocus={true} name={otherInputName as Path<VaultFormData>} label={t(_temp3)} placeholder={t(_temp4)} rules={{
      required: required ? t(_temp5) : undefined
    }} />;
    $[21] = dropdownValue;
    $[22] = includeOther;
    $[23] = otherInputName;
    $[24] = required;
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <div className="flex flex-col gap-4">{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};
function _temp(option) {
  return {
    label: option,
    value: option
  };
}
function _temp2($) {
  return $.dropdown.required;
}
function _temp3($_0) {
  return $_0.otherInputPlaceholder;
}
function _temp4($_1) {
  return $_1.otherInputPlaceholder;
}
function _temp5($_2) {
  return $_2.otherInput.required;
}